import {store} from "@/store";
import {findBy, extract} from "@/lib/utils"
import {ElMessage} from "element-plus"
import {getForAssignment as getCarsForAssignment} from "@/api/cars"
import {getInstrumentsForAssignment} from "@/api/instruments"

export default {
  /**
   * Works
   */
  getCurrentWork(workId) {
    return store.getters["EntityLoader/getEntityById"](workId, "works");
  },
  getPlanWorkTypeIdByWorkId(workId) {
    return this.getCurrentWork(workId)?.planWorkTypeId;
  },
  getWorkTypesIdsByConditionType(conditionType) {
    let suboperations = store.getters["EntityLoader/getEntity"]("suboperations")
    return suboperations.filter(wt => wt.conditionType === conditionType).map(wt => wt.id);
  },
  getAssignmentTypeId(workId) {
    const currentWork = this.getCurrentWork(workId);
    return currentWork ? currentWork.assignmentType : null;
  },
  getAssignmentTypeByAssignmentTypeId(assignmentId) {
    const assignmentTypes = {
      0: {"name": "Простые", "value": "FieldAssignment"},
      1: {"name": "Посевные", "value": "SowingAssignment"},
      2: {"name": "Полевые", "value": "FieldAssignment"},
      3: {"name": "Транспортировка до поля", "value": "ToFieldAssignment"},
      4: {"name": "Транспортировка от поля", "value": "FromFieldAssignment"},
    }
    return assignmentTypes[assignmentId] ? assignmentTypes[assignmentId] : ""
  },
  getStartDateFromWorkDatesByWorkId(workId) {
    let workDates = store.getters["EntityLoader/getEntity"]("workdates")
    let startDate = new Date("1/1/1970")
    for (var i = 0, n = workDates.length; i < n; i++) {
      if (workDates[i].workTypeParameterPlanWorkTypesIds.indexOf(workId) > -1) {
        startDate = new Date(workDates[i].startDate)
        break;
      }
    }
    return startDate
  },
  getAssignmentsWorks() {
    let works = store.getters["EntityLoader/getEntity"]("works");
    return works.filter(w => !this._isFieldAssignment(w))
  },
  _isFieldAssignment(w) {
    return w.assignmentType == 4 || w.assignmentType == 3
  },
  isFieldWork(work) {
    console.log('work', work)
    console.log('work.assignmentType', work.assignmentType)
    return work.assignmentType === "FieldAssignment"
  },
  isSowingWork(work) {
    return work.assignmentType === 'SowingAssignment'
  },
  /**
   * Fuel Norms
   */
  async getInstrumentsIdsFromFuelNorms(workId, carModelId, year) {
    return await getInstrumentsForAssignment(store.getters["Contexts/getOrganizationsGroupId"], year, workId)
  },
  /**
   * Cars
   */
  getCurrentCar(carId) {
    return store.getters["EntityLoader/getEntityById"](carId, "carsall");
  },
  async getCarsForAssignment(workId) {
    let body = {subOperationId: workId, year: store.getters["Contexts/getYear"]}
    let result = await getCarsForAssignment(body)
    return result
  },
  async getCarsFilteredByWorksAndOrganization(workId, organizationId) {
    let cars = store.getters["EntityLoader/getEntity"]("carsall")
    let data = await this.getCarsForAssignment(workId)
    let organizationCars = data.organizationCars
    let carItem = organizationCars.find(item => item.organizationId == organizationId)
    let carIds = carItem && carItem.carIds || []
    let carItemCars = carItem && carItem.cars || []
    return cars.filter(item => carIds.includes(item.id)).map(item => {
      let carItemCar = carItemCars.find(cItem => cItem.carId == item.id)
      item.showWithoutSensorCheckBox = carItemCar && carItemCar.showWithoutSensorCheckBox
      return item
    })
  },
  /**
   * Instruments
   */
  async getInstrumentsFilteredByWorksAndCars(workId, carId, organizationId, year) {
    let instruments = store.getters["EntityLoader/getEntity"]("instruments")
    let organizationInstruments = await this.getInstrumentsFromInstrumentsIds(workId, carId, year)
    // let instrumentsItem = organizationInstruments.find(item => item.organizationId == organizationId)
    // let instrumentsIds = instrumentsItem && instrumentsItem.instrumentIds || []
    return instruments
    // .filter(item => instrumentsIds.includes(item.id))
  },
  async getInstrumentsFromInstrumentsIds(workId, carId, year) {
    let carModelId = this.getCurrentCar(carId).carModelId
    let result = await this.getInstrumentsIdsFromFuelNorms(workId, carModelId, year)
    return result
  },
  /**
   * Employees
   */
  getEmployeesFilteredByOrganization(organizationId) {
    const employees = store.getters["EntityLoader/getEntity"]("employeesall");
    return employees.filter(e => e.organizationId === organizationId);
  },
  /**
   * SeedLimits
   */
  getSeedLimitById(seedLimitId) {
    return store.getters["EntityLoader/getEntityById"](seedLimitId, "seedlimits");
  },
  getCultureDepthById(cultureId) {
    return store.getters["EntityLoader/getEntityByParameter"]({name: "cultureId", value: cultureId, entity: "culturedepths"});
  },
  getMinMaxOfSowingDepths(seedLimitId) {
    const seedLimit = this.getSeedLimitById(seedLimitId);
    if (!seedLimit) return {}
    const cultureDepth = this.getCultureDepthById(seedLimit.cultureId);
    const exclusionCultures  = [17, 24, 39]
    if (!cultureDepth && !exclusionCultures.includes(seedLimit.cultureId)) {
      ElMessage({
        message: `Заполните глубину посева культуры: ${seedLimit.cultureName}`,
        type: "warning",
        duration: 5000,
        showClose: false,
      })
      return {}
    }
    return cultureDepth
  },
  /**
   * Organization
   */
  getOrganization(organizationId) {
    let organizations = store.getters["EntityLoader/getEntity"]("userorganizations")
    let contextOrganization = organizationId || store.getters["Contexts/getOrganization"]
    let organization = findBy(organizations, "id", contextOrganization, true)
    return organization
  },
  getOrganizationType(organizationId) {
    let organization = this.getOrganization(organizationId)
    let organizationType = extract(organization, "organizationType")
    return organizationType
  },
  getOrganizationGuid(organizationId) {
    let organization = this.getOrganization(organizationId)
    let organizationType = extract(organization, "guid")
    return organizationType
  },
  getOrganizationGroupGuid(organizationId) {
    let organization = this.getOrganization(organizationId)
    let guid = extract(organization, "organizationsGroupGuid")
    return guid
  },
  isFarm(organizationId) {
    let organizationType = this.getOrganizationType(organizationId)
    return organizationType === "Farm"
  },
  isElevator(organizationId) {
    let organizationType = this.getOrganizationType(organizationId)
    return organizationType === 1
  },
  isGroup(organizationId) {
    let organizationType = this.getOrganizationType(organizationId)
    return organizationType === 2
  },
}
